import CloseIcon from '@material-ui/icons/Close'
import React, { useState } from 'react'

import { SanityNotificationWithLink } from '../../../graphql/gatsby'
import { useSanityContextBasedContent, useSanityRoleBasedContent } from '../../../lib/sanity'
import * as Styled from './styled'

export type NotificationWithLinkProps = SanityNotificationWithLink

export const NotificationWithLink: React.FC<NotificationWithLinkProps> = React.memo(
  ({ notificationMessageWithLink }) => {
    const {
      notificationMessage,
      notificationCTA,
      backgroundColor,
      textColor,
      contextBasedContent,
      roleBasedContent,
    } = notificationMessageWithLink || {}
    const [isVisible, setIsVisible] = useState(true)
    const { shouldDisplay: shouldDisplayForRole } = useSanityRoleBasedContent({ roleBasedContent })
    const { shouldDisplay: shouldDisplayForContext } = useSanityContextBasedContent({
      contextBasedContent,
    })

    const shouldDisplay =
      (shouldDisplayForRole || shouldDisplayForContext) &&
      !!notificationMessageWithLink &&
      isVisible

    if (!shouldDisplay) return null

    return (
      <Styled.Container textColor={textColor?.color} backgroundColor={backgroundColor?.color}>
        <Styled.Wrapper>
          <Styled.Text>{notificationMessage}</Styled.Text>
          {notificationCTA?.link && (
            <Styled.Link to={notificationCTA?.link}>{notificationCTA?.title}</Styled.Link>
          )}
          <Styled.CloseButton textColor={textColor?.color} onClick={() => setIsVisible(false)}>
            <CloseIcon />
          </Styled.CloseButton>
        </Styled.Wrapper>
      </Styled.Container>
    )
  },
)

NotificationWithLink.displayName = 'NotificationWithLink'
